import { Ng2StateDeclaration } from '@uirouter/angular';
import { RequestAccessComponent } from '@fi-app/user/request-access/request-access.component';
import { UserService } from '@fi-app/user/user.service';
import { FiStateResolveAccessRightFilterCollection } from '@fi-app/utilities/state-resolve/access-right-filter-collection';
import { FiStateResolveContentLanguages } from '@fi-app/utilities/state-resolve/content-languages';
import { FiStateResolveApplicationLanguages } from '@fi-app/utilities/state-resolve/application-languages';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AccessRightFilterCollectionModel } from '@fi-shared/models';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginRequestAccessState: Ng2StateDeclaration = {
    name: FiStateNames.Login.RequestAccess,
    url: '/RequestAccess',
    component: RequestAccessComponent,
    resolve: {
        user: [UserService, FiCustomerDataService, FiAuthStatesLoginRequestAccessResolve_user],
        accessRightFilterCollection: FiStateResolveAccessRightFilterCollection,
        availableBusinessUnits: [FiAuthStatesLoginRequestAccessStateResolve_availableBusinessUnits],
        lightWeightBusinessUnits: [
            'accessRightFilterCollection',
            FiAuthStatesLoginRequestAccessResolve_lightWeightBusinessUnits,
        ],
        contentLanguages: FiStateResolveContentLanguages,
        applicationLanguages: FiStateResolveApplicationLanguages,
        pageTitle: [PageTitleService, FiAuthStatesLoginRequestAccessResolve_pageTitle],
    },
};

export function FiAuthStatesLoginRequestAccessResolve_user(
    userService: UserService,
    customerDataService: FiCustomerDataService,
) {
    const userPromise = userService.getNewUserInstance();
    userPromise.then((u) => (u.ApplicationLanguageType = customerDataService.customerData.UserApplicationLanguageType));
    return userPromise;
}

export function FiAuthStatesLoginRequestAccessResolve_lightWeightBusinessUnits(
    accessRightFilterCollection: AccessRightFilterCollectionModel,
) {
    return accessRightFilterCollection.AccessRightCoreFilter.BusinessUnits.slice();
}

export function FiAuthStatesLoginRequestAccessResolve_pageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Request access');
}

export function FiAuthStatesLoginRequestAccessStateResolve_availableBusinessUnits() {
    return [];
}
